import { useEffect } from "react";
import { NaeSSchemaMap } from '../../_custom/config/NaeSSchema';
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorSalesOfferNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface ISalesOfferModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
      serialNumber: string,
  }

export const ISalesOfferFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges",
    "serialNumber"
];

export function useSalesOfferHookNae(id: number) : ISalesOfferModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorSalesOfferNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: NaeSSchemaMap.SalesOffer.schema,
        fields: ISalesOfferFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
